// Owner-confirmed booking minimums (Oct 2026). Reuse these FAQ entries instead of
// rewording the rule per page, so every page states exactly the same minimums.
export const HOURLY_MINIMUM_HOURS = 4;
export const PROM_MINIMUM_HOURS = 6;
export const WEEKEND_MINIMUM_HOURS = 6;

export type MinimumFaq = { q: string; a: string; group?: string };

/** FAQ entry for hourly service. `transfers` adds the note that airport/FBO transfers are quoted flat. */
export function hourlyMinimumFaq(opts: { transfers?: boolean; weekend?: boolean; group?: string } = {}): MinimumFaq {
  const transfers = opts.transfers
    ? " Airport and private-terminal transfers are quoted as a flat door-to-door rate instead."
    : "";
  const weekend = opts.weekend ? ` (${WEEKEND_MINIMUM_HOURS} hours on weekends)` : "";
  return {
    q: "Is there a minimum number of hours?",
    a: `Yes. Hourly service has a ${HOURLY_MINIMUM_HOURS}-hour minimum${weekend}. Your vehicle and chauffeur are reserved for your booking alone for that time, and more hours can always be added. Your full quote is in writing before you book.${transfers}`,
    ...(opts.group ? { group: opts.group } : {}),
  };
}

/** FAQ entry for prom night. */
export function promMinimumFaq(opts: { group?: string } = {}): MinimumFaq {
  return {
    q: "Is there a minimum for prom?",
    a: `Yes. Prom bookings have a ${PROM_MINIMUM_HOURS}-hour minimum, which is the industry standard for prom night. Photos at home, dinner, the dance and the ride home usually fill those hours, and more hours can always be added. Your full quote is in writing before you book, so it is easy to share with the other parents.`,
    ...(opts.group ? { group: opts.group } : {}),
  };
}
